// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZZKT4","clinicsSelect":"styles_clinicsSelect__1vW8-"};